
export const ApiActions = {
    ADD: "ADD",
    EDIT: "EDIT",
}
